import { isBefore } from 'date-fns';
import { Component, Show } from 'solid-js';
import { StyledProductRegNoItem } from './products.styles';

export type RegNoItem = {
    status: string;
    Icon: Component;
    statusText: string;
    name: string;
    id: string;
    regNumber: string;
    productName: string;
    productSlug: string;
    productRegistrationNumber: string;
    approvalCeasedDate: string | null;
    usageForbiddenDate: string | null;
};

type Props = {
    regNo: RegNoItem;
};

export const RegnoItem = (props: Props) => (
    <StyledProductRegNoItem>
        <div class="row">
            <strong>{props.regNo.regNumber}</strong>
            <props.regNo.Icon />
            <span>({props.regNo.statusText})</span>
        </div>
        <Show when={props.regNo.approvalCeasedDate}>
            <div class="row">
                <strong>
                    {isBefore(new Date(props.regNo.approvalCeasedDate || new Date()), new Date())
                        ? 'Godkännande upphörde:'
                        : 'Godkännande upphör:'}
                </strong>
                <div>{props.regNo.approvalCeasedDate}</div>
            </div>
        </Show>
        <Show when={props.regNo.usageForbiddenDate}>
            <div class="row">
                <strong>Sista användningsdag:</strong>
                <div>{props.regNo.usageForbiddenDate}</div>
            </div>
        </Show>
    </StyledProductRegNoItem>
);
